import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/partials/Layout'
import Users from '../components/LicensedUsers'
import Admins from '../components/AdminUsers'
import Groups from '../components/Groups'
import Form from '../components/Form'
import Group from '../components/Group'
import Category from '../components/Category'
import Devices from '../components/Devices'
import Dashboard from '../views/dashboard'
import LogIn from '../views/pages/login'
import Register from '../views/pages/register'
import Error404 from '../views/pages/error-404'
import GroupForm from '../components/GroupForm'
import User from '../components/User'
import Companies from '../components/Companies'
import Categories from '../components/Categories'
import CompanyForm from '../components/CompanyForm'
import Company from '../components/Company'
import Licenses from '../components/Licenses'
import PrivacyPolicy from '../views/privacy_policy'
import DownloadCenter from '../components/DownloadCenter'
import Support from '../components/Support'
import PrintPage from '../components/PrintPage'
import MigrationTemp from '../components/MigrationTemp'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/forms-migration',
      component: MigrationTemp,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/privacy_policy.html',
      component: PrivacyPolicy
    },
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/print/',
      name: 'PrintPreview',
      component: PrintPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      component: Layout,
      name: 'DashboardLayout',
      redirect: '/dashboard',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/system-admins',
          name: 'Admins',
          component: Admins
        },
        {
          path: '/system-admins/new',
          name: 'Admin Form',
          component: User
        },
        {
          path: '/companies',
          name: 'Companies',
          component: Companies
        },
        {
          path: '/companies/new',
          name: 'Company Form',
          component: CompanyForm
        },
        {
          path: '/companies/:id',
          name: 'Company',
          component: Company
        },
        {
          path: '/devices/',
          name: 'Devices',
          component: Devices
        },
        {
          path: '/licensed-users',
          name: 'Licensed Users',
          component: Users
        },
        {
          path: '/users/edit/',
          name: 'Edit User',
          component: User
        },
        {
          path: '/users/:id',
          name: 'User',
          component: User
        },
        {
          path: '/groups/:groupId/forms/:id',
          name: 'Form',
          component: Form
        },
        {
          path: '/group/:id',
          name: 'AdminGroup',
          component: Group
        },
        {
          path: '/companies/:company/group/:id',
          name: 'Group',
          component: Group
        },
        {
          path: '/company/:id',
          name: 'AdminCategory',
          component: Category,
          props: true
        },
        {
          path: '/my-companies',
          name: 'Categories',
          component: Categories,
          props: true
        },
        {
          path: '/companies/:company/category/:id',
          name: 'Category',
          component: Category,
          props: true
        },
        {
          path: '/groups',
          name: 'Groups',
          component: Groups
        },
        {
          path: '/groups/new',
          name: 'New Group',
          component: GroupForm
        },
        {
          path: '/groups/edit/',
          name: 'Edit Group',
          component: GroupForm
        },
        {
          path: '/licenses/',
          name: 'Licenses',
          component: Licenses
        },
        {
          path: '/my-licenses/',
          name: 'My Licenses',
          component: Licenses
        },
        {
          path: '/download-center/',
          name: 'Download Center',
          component: DownloadCenter
        },
        {
          path: '/support/',
          name: 'Nordtech Support',
          component: Support
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Error404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js